import { Flex, Typography } from "antd";
import React, { useMemo } from "react";
import classname from "classname";
import MonthStatus from "../../../../VAMP/components/MonitoringProgram/MonthStatus/MonthStatus";
import { getMonitoringMonthIcon } from "../../../../VAMP/utils/getMonitoringMonthIcon";
import { formatCurrency } from "../../../../../../Utils/utils";
import "../../../../VAMP/components/MonitoringProgram/MonthBlock/MonthBlock.less";

const EFMMonthBlock = ({ data, currentMonth, styles, isMobile = false }) => {
  const { icon, variant } = useMemo(
    () => getMonitoringMonthIcon(data.icon, data.status),
    [data]
  );

  const rateText = `${data.fraud_rate ?? 0}%`;
  const volumeText = formatCurrency(data.net_fraud_volume ?? 0, true);
  const threeDsText = `${data.three_ds_usage_rate ?? 0}% 3DS`;

  if (isMobile) {
    return (
      <Flex
        className={classname("bh-monitoring-month-block", "is-mobile", variant)}
        style={styles}
        vertical
        gap={8}
      >
        <Flex align="center" gap={8}>
          <MonthStatus icon={icon} variant={variant} />
          <Typography.Text className="month-title">{data.month_name}</Typography.Text>
        </Flex>
        <Flex vertical gap={2} className="month-metrics">
          <Typography.Text type="secondary">
            <span className={classname("text-number", variant)}>{rateText}</span>
          </Typography.Text>
          <Typography.Text type="secondary">
            <span className={classname("text-number", variant)}>{volumeText}</span>
          </Typography.Text>
          <Typography.Text type="secondary">
            <span className={classname("text-number", variant)}>{threeDsText}</span>
          </Typography.Text>
        </Flex>
      </Flex>
    );
  }

  return (
    <Flex
      className="bh-monitoring-month-block"
      style={styles}
      vertical
      align="center"
      gap={8}
    >
      <MonthStatus icon={icon} variant={variant} />
      <div
        className={classname("month-name", {
          current: data.month === currentMonth,
        })}
      >
        <Typography.Text type="secondary">{data.month_name}</Typography.Text>
      </div>
      <Flex vertical align="center" gap={2}>
        <Typography.Text type="secondary" className={classname("text-number", variant)}>
          {rateText}
        </Typography.Text>
        <Typography.Text type="secondary" className={classname("text-number", variant)}>
          {volumeText}
        </Typography.Text>
        <Typography.Text type="secondary" className={classname("text-number", variant)}>
          {threeDsText}
        </Typography.Text>
      </Flex>
    </Flex>
  );
};

export default EFMMonthBlock;
